import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import {
    getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, settings, getResponse, getLanguageObj
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { LargeLanguageModelService } from '../../services/largeLanguageModel/LargeLanguageModelService';
import { LargeLanguageModelClass } from '../../classes/ai/largeLanguageModelClass';

const { html, icons, labels, messages, images } = settings;

const currentMethod = 'LargeLanguageModelAddEditDetails - function';

export default function LargeLanguageModelAddEditDetails({
    $ = {},
    auth = {},
    processValues = {
        id: '',
        description: '',
        method: '',
        dtId: '',
        dtRowId: 0,
        type: 0,
        subMethod: ''
    },
    setProcessValues = () => { },
    showModal = false,
    setShowModal = () => { },
    largeLanguageModel = LargeLanguageModelClass?.getClass(),
    setLargeLanguageModel = () => { },
    largeLanguageModels = [LargeLanguageModelClass?.getClass()],
    setLargeLanguageModels = () => { },
    dateTimeFormat = { date: '', time: 0 },
    setDtRow = ({
        data = LargeLanguageModelClass?.getClass(),
        subMethod = '',
    }) => { },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [errors, setErrors] = useState({ code: '', description: '' });
    const [process, setProcess] = useState({ showLoading: false, save: false });

    const isMount = useRef(true);
    const chkLargeLanguageModelRef = useRef(null);
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        isModalClose = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setErrors({ description: '' });
            if (isModalClose) {
                setLargeLanguageModel({});
                setShowModal(!isModalClose);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
    };

    const largeLanguageModelAddEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'largeLanguageModelAddEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            if (processValues?.type === 0) {
                response = await LargeLanguageModelService.create({
                    token: auth?.account?.tokenVzLaML?.token,
                    data: {
                        ...largeLanguageModel,
                        languageObj: languageObj?.id,
                    },
                    subMethod: currentMethod,
                });
            } else if (processValues?.type === 1) {
                response = await LargeLanguageModelService.update({
                    id: largeLanguageModel?.id,
                    token: auth?.account?.tokenVzLaML?.token,
                    data: {
                        ...largeLanguageModel,
                        languageId: languageObj?.id,
                    },
                    subMethod: currentMethod,
                });
            }
            if (!response?.isSuccess || response?.isWarning) return;

            const largeLanguageModel_ = response?.result || {};
            setLargeLanguageModel(largeLanguageModel_);

            const dtRow = setDtRow({
                data: largeLanguageModel_,
                subMethod: currentMethod
            })?.result;

            if (processValues?.type === 0) {
                $(`#${processValues?.dtId}`).DataTable().row.add(dtRow).draw();
                setLargeLanguageModels(prev => [...prev, largeLanguageModel_]);
            } else if (processValues?.type === 1) {
                $(`#${processValues?.dtId}`).DataTable().row(processValues?.dtRowId).data(dtRow).draw();
                setLargeLanguageModels(prev => prev.map(llm => llm?.id === processValues?.id ? largeLanguageModel_ : llm));
            }
            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}<br/>`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ isModalClose: true, subMethod: currentMethod });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { code: '', description: '' };

            if (isUndNullEmpNew({ data: largeLanguageModel?.code, subMethod: currentMethod })?.result) {
                errors_.code = thisFieldRequired;
                response = getResponse({ type: 1 });
            }
            if (isUndNullEmpNew({ data: largeLanguageModel?.description, subMethod: currentMethod })?.result) {
                errors_.description = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setFormValue = ({
        key = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormValue';
        let response = getResponse({ type: 0 });
        try {
            setLargeLanguageModel(prev => ({ ...prev, [key]: value }));

            if (key === 'description' && value !== '') {
                setErrors(prev => ({ ...prev, description: '' }));
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (showModal) {
                setErrors({
                    description: '',
                });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, [largeLanguageModel?.id]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static'
            onHide={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalClose' })}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='commandLogo' src={images?.icons?.largeLanguageModels} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.largeLanguageModel?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${processValues?.type === 0 ? 'badge-info' : 'badge-warning text-dark'}`}
                            style={html?.badges?.micro}>
                            {processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => largeLanguageModelAddEdit({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body className='px-4 pt-2'>
                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.code?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.key} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.code?.[languageObj?.id]}
                                type='text'
                                onChange={(e) => setFormValue({ key: 'code', value: e?.target?.value, subMethod: 'inputCode' })}
                                onFocus={() => setErrors(prev => ({ ...prev, code: '' }))}
                                placeholder={labels?.code?.[languageObj?.id]}
                                value={largeLanguageModel?.code || ''}
                                disabled={process?.showLoading} />
                        </div>
                        {errors?.code && <div className={html?.errorText}>{HtmlParser(errors?.code)}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                            {labels?.description?.[languageObj?.id]}
                        </label>
                        <div className='position-relative'>
                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                            <input className='form-control border-0 shadow-sm form-input-icon'
                                title={labels?.description?.[languageObj?.id]}
                                type='text'
                                onChange={(e) => setFormValue({ key: 'description', value: e?.target?.value, subMethod: 'inputDescription' })}
                                onFocus={() => setErrors(prev => ({ ...prev, description: '' }))}
                                placeholder={labels?.description?.[languageObj?.id]}
                                value={largeLanguageModel?.description || ''}
                                disabled={process?.showLoading} />
                        </div>
                        {errors?.description && <div className={html?.errorText}>{HtmlParser(errors?.description)}</div>}
                    </div>

                    <div className='form-group mb-4'>
                        <div className='icheck-primary d-inline'>
                            <input type='checkbox'
                                id={'chkLargeLanguageModelId'}
                                ref={chkLargeLanguageModelRef}
                                checked={largeLanguageModel?.enabled || false}
                                onChange={(e) => setFormValue({ key: 'enabled', value: e?.target?.checked, subMethod: 'chkEnabled' })}
                                disabled={process?.showLoading} />
                            <label htmlFor={'chkLargeLanguageModelId'} style={{ cursor: 'pointer' }}>
                                {labels?.enabled?.[languageObj?.id]}?
                            </label>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setDefaultValue({ isModalClose: true, subMethod: 'btnFooterCloser' })}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}